import { render, staticRenderFns } from "./StarLine.vue?vue&type=template&id=0f579476"
import script from "./StarLine.vue?vue&type=script&lang=js"
export * from "./StarLine.vue?vue&type=script&lang=js"
import style0 from "./StarLine.vue?vue&type=style&index=0&id=0f579476&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports